import React from 'react';
import { useDispatch } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import { walletDrawerActions } from '@share/store/slices';

import styles from './styles.module.scss';

export const WalletDrawerTrigger = (): React.ReactElement => {
  const dispatch = useDispatch();

  const handleClick = (): void => {
    dispatch(walletDrawerActions.setWalletDrawerOpen(true));
  };

  return (
    <button className={styles.trigger} type="button" onClick={handleClick}>
      <span>
        <FormattedMessage id="certificates.wallet.drawerTitle" />
      </span>
    </button>
  );
};
